export default {
    yes: 'Yes',
    no: 'No',
    toDo: 'To-Do',
    athletes: 'Clients',
    dietPlan: 'Diet plan',
    dietPlans: 'Diet plans',
    loading: 'Loading',
    viewAll: 'View All',
    options: 'Options',
    filterByTag: {
        title: 'Filter by tag'
    },
    tags: 'Tags',
    add: 'Add',
    addTag: 'Add tag',
    existingTag: 'Select an existing tag',
    view: 'View',
    from: 'From',
    to: 'To',
    createdAt: 'Creation date',
    updatedAt: 'Last update',
    dropCsv: 'Drop a CSV file or click here to select',
    dropImg: 'Drop an image or click here to select',
    imageTooBig: 'The image exceeds the {size} size limit',
    saveAsPdf: 'Save as PDF',
    print: 'Print',
    colorPick: 'Select color',
    fullName: 'Full Name',
    value: 'Value',
    left: 'L',
    right: 'R',
    leg: 'Leg',
    hand: 'Hand',
    age: {
        years: 'Years',
        months: 'Months',
        days: 'Days',
        hours: 'Hours'
    },
    optionalField: "{field} (optional)",
    preview: 'Preview',
    uploading: 'Uploading...',
    saving: 'Saving...',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    undo: 'Undo',
    redo: 'Redo',
    timezonePrompt: {
        title: 'Set Your Timezone',
        description: 'To ensure accurate times for calendar events and scheduled activities, please select your timezone.'
    },
    timezoneMismatch: {
        title: 'Timezone Mismatch Detected',
        description: 'Your saved timezone doesn\'t match your browser\'s detected timezone. Would you like to update it?',
        saved: 'Currently saved',
        detected: 'Browser detected',
        keepCurrent: 'Keep current',
        switchToDetected: 'Switch to detected'
    },
    hour: 'Hour',
    hours: 'Hours',
    actions: 'Actions',
    search: 'Search',
    noResults: 'No results found'
}
